import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationsService } from '../services/notifications.service';
import { NotificationType, ToastType } from '@shared/models/notifications/notifications.models';

export enum ExceptionType {
  authentication = 'authentication',
  authorization = 'authorization',
  validation = 'validation',
  notFound = 'notFound',
  serverError = 'serverError',
}

interface ErrorResponse {
  type?: string;
  payload?: {
    title?: string;
    message?: string;
    status?: number;
    type?: string;
  };
  title?: string;
  message?: string;
}

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const notificationsService = inject(NotificationsService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // 401s are owned by the auth interceptor (token refresh / sign-out). A raw
      // "401 Unauthorized" toast is noise that piles on top of the real error, so
      // suppress it here and let the auth flow handle the response.
      if (err.status === 401) {
        return throwError(() => err);
      }

      // Extract error information
      const errorData = err.error as ErrorResponse | undefined;
      const errorTitle = errorData?.payload?.title || errorData?.title || 'Error';
      const errorMessage = (
        errorData?.payload?.message || errorData?.message || err.message || 'An error occurred'
      ).trim();

      // Show notification
      notificationsService.setNotification({
        type: NotificationType.Error,
        payload: {
          type: ToastType.error,
          title: errorTitle,
          message: errorMessage,
          status: err.status,
        },
      });

      return throwError(() => err);
    }),
  );
}
